import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './global/page/page-not-found/page-not-found.component';
import { SearchPageComponent } from './global/page/search/search.page.component';
import { CampaignComponent } from './global/page/campaign/campaign.component';
import { DonorAddComponent } from './vortex/page/donor-add/donor-add.component';
import { DonorBulkUpdateComponent } from './vortex/page/donor-bulk-update/donor-bulk-update.component';
import { DonorManualDedupesComponent } from './vortex/page/donor-manual-dedupes/donor-manual-dedupes.component';
import { DonorFlagsComponent } from './vortex/page/donor-flags/donor-flags.component';
import { DonorCallSheetsComponent } from './vortex/page/donor-call-sheets/donor-call-sheets.component';
import { LoginComponent } from './global/page/login/login.component';
import { TwoFactorAuthComponent } from './vortex/page/two-factor/two-factor-auth.component';
import { TwoFactorOptionsComponent } from './vortex/page/two-factor-options/two-factor-options.component';
import { PhoneVerificationComponent } from './global/page/phone-verification/phone-verification.component';
import { RegisterComponent } from './global/page/register/register.component';
import { DashboardComponent } from './global/page/dashboard/dashboard.component';
import { authGuard } from './vortex/guards/auth.guard';
import { UserCampaignInviteComponent } from './vortex/page/user-campaign-invite/user-campaign-invite.component';
import { StyleguideComponent } from './global/page/styleguide/styleguide.component';
import { DefaultComponent } from './template/default/default.component';
import { FullPageComponent } from './template/full-page/full-page.component';
import { SelectCampaignComponent } from './global/page/select-campaign/select-campaign.component';
import { DonorCardComponent } from './vortex/page/donor-card/donor-card.component';
import { DonationCardComponent } from './vortex/page/donation-card/donation-card.component';
import { UsersComponent } from './global/page/users/users.component';
import { AdminComponent } from './vortex/page/admin/admin.component';
import { LoadingPageComponent } from './global/page/loading-page/loading-page.component';
import { ForgetPasswordComponent } from './vortex/page/forget-password/forget-password.component';
import { ResetPasswordComponent } from './vortex/page/reset-password/reset-password.component';
// import { ReportingCenterComponent } from './vortex/page/reporting-center/reporting-center.component';
import { DonorCycleReportComponent } from './vortex/page/reports/donors/donor-cycle-report/donor-cycle-report.component';
import { DonorDonationsListReportComponent } from './vortex/page/reports/donations/donor-donations-list-report/donor-donations-list-report.component';
import { ExpenseTransactionsReportComponent } from './vortex/page/reports/expenses/expense-transactions-report/expense-transactions-report.component'; 
import { CampaignSettingsFundCodesComponent } from './vortex/page/campaign-settings-fundcodes/campaign-settings-fundcodes.component';
import { CampaignSettingsComplianceComponent } from './vortex/page/campaign-settings-compliance/campaign-settings-compliance.component';
import { CampaignSettingsSearchThrottleComponent } from './vortex/page/campaign-settings-search-throttle/campaign-settings-search-throttle.component';
import { FundraisersEventsComponent } from './vortex/page/events-search/events-search.component';
import { CampaignSettingsAccountingSystemsComponent } from './vortex/page/campaign-settings-accouting-systems/campaign-settings-accouting-systems.component';
import { ExpensesComponent } from './vortex/page/expenses/expenses.component';
import { ExpenseSearchMobileComponent } from './vortex/page/expenses/expense-search-mobile/expense-search-mobile.component';
import { DonorSearchComponent } from './vortex/page/donor-search/donor-search.component';
import { DonationsSearchComponent } from './vortex/page/donations-search/donations-search.component';
import { FundraiserAddComponent } from './vortex/page/fundraisers-add/fundraiser-add.component';
import { FundraiserCardComponent } from './vortex/page/fundraiser-card/fundraiser-card.component';
import { FundraiserHistoryComponent } from './vortex/page/fundraiser-card/fundraiser-history/fundraiser-history.component';
import { FundraiserAmountsComponent } from './vortex/page/fundraiser-card/fundraiser-amounts/fundraiser-amounts.component';
import { DownloadReportComponent } from './vortex/page/reports/download-report/download-report.component';
import { DonationUploadComponent } from './vortex/page/donations-upload/donation-upload.component';
import { JobsComponent } from './vortex/page/reports/jobs/jobs.component';

let urlMap:Map<string, string>|null = null;

export const routes: Routes = [
    {
        path: 'loading',
        component: LoadingPageComponent,
    },

        {
          path: 'login',
          component: FullPageComponent,
          children: [
              { 
                      path: '', 
                      component: LoginComponent 
              },
          ]
        },
        {
          path: 'twofa-options',
          component: FullPageComponent,
          children: [
            {
              path: '',
              component: TwoFactorOptionsComponent
            },
          ]
        },
        {
          path: 'twofa-auth',
          component: FullPageComponent,
          children: [
            {
              path: '',
              component: TwoFactorAuthComponent
            },
          ]
        },
        {
          path: 'phone-verification',
          component: FullPageComponent,
          children: [
            {
              path: '',
              component: PhoneVerificationComponent
            },
          ]
        },
        {
        path: 'forgot-password',
        component: FullPageComponent,
        children: [
            {
                path: '',
                component: ForgetPasswordComponent
            },
        ]
    },
    {
        path: 'reset-password',
        component: FullPageComponent,
        children: [
            {
                path: '',
                component: ResetPasswordComponent
            },
        ]
    },
    {
        path: 'register',
        component: FullPageComponent,
        data: {
            breadcrumb: "Register",
        },
        children: [
            { 
                path: '', 
                component: RegisterComponent 
            },
        ]
        },
    {
        path: '',
        component: DefaultComponent,
        children: [
            {
                path: 'campaign-selection',
                data: {
                    breadcrumb: "Select a Campaign"
                },
                component: SelectCampaignComponent,
                canActivate: [authGuard]
            },
            { 
                path: "vortex", 
                data: {
                    breadcrumb: "Home",
                },
                component: CampaignComponent,
                canActivate: [authGuard]
            },
            {
                path: "vortex/campaign-dashboard", 
                component: DashboardComponent, 
                pathMatch: "full",
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Campaign Dashboard",
                }
            },

            // DONORS 
            //--------------------------------------------------------------------
            {
                path: "vortex/donors/donor-search", 
                component: DonorSearchComponent, 
                pathMatch:"full",
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donors",
                }
            },
            {
                path: "vortex/donors/card/:id",
                component: DonorCardComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donor"
                }
            },
            {
                path: "vortex/donors/add-new-donor", 
                component: DonorAddComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Add New Donor",
                },
            },
            {
                path: "vortex/donors/donor-dedupe", 
                component: DonorManualDedupesComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Dedupe Donors",
                },
            },
            {
                path: "vortex/donors/donor-flags", 
                component: DonorFlagsComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donor Flags",
                },
            },
            {
                path: "vortex/donors/donor-call-sheets", 
                component: DonorCallSheetsComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donor Call Sheets",
                },
            },

            // DONATIONS  
            //--------------------------------------------------------------------
            { 
                path: "vortex/donations/donation-search", 
                // loadComponent: () => import('./global/page/search/search.page.component').then( (x) => x.SearchPageComponent ),
                // loadComponent: () => import('./vortex/page/donations-search/donations-search.component').then( (x) => x.DonationsSearchComponent ),
                component:DonationsSearchComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donations",
                }
            },
            {
                path: "vortex/donations/donation-card",
                component: DonationCardComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donation Card"
                }
            },
            {
                path: "vortex/donations/add-new-donation", 
                loadComponent: () => import('./vortex/page/donations-add/donations-add.component').then( (x) => x.DonationsAddComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Add New Donation",
                    },
            },
            {
                path: "vortex/donations/donation-batches", 
                loadComponent: () => import('./vortex/page/donation-batches/donation-batches.component').then( (x) => x.DonationBatchesComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donation Batches",
                    },
            },
            {
              path: "vortex/donations/edit-donation-batch/:batchId",
              loadComponent: () => import('./vortex/page/donation-batches/edit-donation-batch/edit-donation-batch.component').then((x) => x.EditDonationBatchComponent),
              canActivate: [authGuard],
              data: {
                breadcrumb: "Edit Donation Batches",
              },
            },
            {
                path: "vortex/donations/donation-flags", 
                loadComponent: () => import('./vortex/page/donations-flags/donations-flags.component').then( (x) => x.DonationsFlagsComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donation Flags",
                    },
            },

            // FUNDRAISING ACTIVITY 
            //--------------------------------------------------------------------
            { 
                path: "vortex/fundraising-activity/fundraisers", 
                loadComponent: () => import('./global//page/fund-raising/fund-raising.component').then( (x) => x.FundRaisingComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Fundraisers",
                }
            },
            {
                path: "vortex/fundraising-activity/events", 
                component: FundraisersEventsComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Events",
                    },
            },
            {
                path: "vortex/fundraising-activity/event/:id", 
                loadComponent: () => import('./vortex/page/event-details/event-details.component').then( (x) => x.EventDetailsComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Event",
                    },
            },
            {
                path: "vortex/fundraising-activity/initiatives", 
                loadComponent: () => import('./vortex/page/fundraisers-initiatives/fundraisers-initiatives.component').then( (x) => x.FundraisersInitiativesComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Initiatives",
                    },
            },
            {
                path: "vortex/fundraising-activity/app-fundraiser-add", 
                component: FundraiserAddComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Add Fundraiser",
                },
            },
            {
                path: "vortex/page/fundraiser-card/:id", 
                component: FundraiserCardComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Fundraiser Card",
                },
            },
            {
                path: "vortex/page/fundraiser-card/fundraiser-history", 
                component: FundraiserHistoryComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Fundraiser History",
                },
            },
            {
                path: "vortex/page/fundraiser-card/fundraiser-amounts", 
                component: FundraiserAmountsComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Fundraiser Amounts",
                },
            },
            
            // EXPENSES
            //--------------------------------------------------------------------
            { 
                path: "vortex/expenses/expense-search", 
                component: ExpensesComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Expense Search",
                }
            },
            { 
                path: "vortex/expenses/expense-search-mobile", 
                component: ExpenseSearchMobileComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Expense Mobile Search",
                }
            },
            { 
                path: "vortex/expenses/add-new-expense", 
                component: PageNotFoundComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Add New Expense",
                }
            },

            // REPORTING CENTER
            //--------------------------------------------------------------------
            // { 
            //     path: "vortex/reporting-center", 
            //     component: ReportingCenterComponent,
            //     canActivate: [authGuard],
            //     data: {
            //         breadcrumb: "Reporting Center",
            //     }
            // },
            
            { 
                path: "vortex/reports/donors/donor-cycle", 
                component: DonorCycleReportComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donor Cycle",
                }
            },
            { 
                path: "vortex/reports/donations/donor-donations-list", 
                component: DonorDonationsListReportComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donor Donations List",
                }
            },
            { 
                path: "vortex/reports/expenses/expense-transactions", 
                component: ExpenseTransactionsReportComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Expense Transactions",
                }
            },
            { 
                path: "vortex/reports/jobs", 
                component: JobsComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Jobs",
                }
            },
            { 
                path: "vortex/reports/download-report", 
                component: DownloadReportComponent, 
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Download Report",
                }
            },
            // { 
            //     path: "vortex/reporting-center/system-reports", 
            //     component: PageNotFoundComponent,
            //     canActivate: [authGuard],
            //     data: {
            //         breadcrumb: "System Reports",
            //     }
            // },
            // { 
            //     path: "vortex/reporting-center/custom-reports", 
            //     component: PageNotFoundComponent,
            //     canActivate: [authGuard],
            //     data: {
            //         breadcrumb: "Custom Reports",
            //     }
            // },

            // FEC
            //--------------------------------------------------------------------
            { 
                path: "vortex/fec/vortex-filer", 
                loadComponent: () => import('./vortex/page/fec-vortex/fec-vortex.component').then( (x) => x.FecVortexComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Vortex Filer",
                }
            },
            { 
                path: "vortex/fec/fec-settings", 
                loadComponent: () => import('./vortex/page/fec-settings/fec-settings.component').then( (x) => x.FecSettingsComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "FEC Settings",
                }
            },
            { 
                path: "vortex/fec/fec-report-cleanup", 
                loadComponent: () => import('./vortex/page/fec-report-cleanup/fec-report-cleanup.component').then( (x) => x.FecReportCleanupComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "FEC Report Cleanup",
                }
            },

            // JFC
            //--------------------------------------------------------------------
            { 
                path: "vortex/jfc/allocation-settings", 
                loadComponent: () => import('./vortex/page/jfc-allocation-settings/jfc-allocation-settings.component').then( (x) => x.JfcAllocationSettingsComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Allocation Settings",
                }
            },
            { 
                path: "vortex/jfc/distributions", 
                loadComponent: () => import('./vortex/page/jfc-distributions/jfc-distributions.component').then( (x) => x.JfcDistributionsComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Distributions",
                }
            },
            { 
                path: "vortex/jfc/batches", 
                loadComponent: () => import('./vortex/page/jfc-batches/jfc-batches.component').then( (x) => x.JfcBatchesComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Batches",
                }
            },

            // ===================================================================
            // VORTEX LITE
            //--------------------------------------------------------------------
            { 
                path: "vortex-lite", 
                loadComponent: () => import('./global/page/search/search.page.component').then( (x) => x.SearchPageComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "My Fundraising Tally",
                }
            },
            { 
                path: "vortex-lite/fundraising-tally", 
                loadComponent: () => import('./vortex/page/vortex-lite/fundraising-tally/fundraising-tally.component').then( (x) => x.FundraisingTallyComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "My Fundraising Tally",
                }
            },
            { 
                path: "vortex-lite/events", 
                loadComponent: () => import('./global/page/search/search.page.component').then( (x) => x.SearchPageComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Events",
                }
            },
            { 
                path: "vortex-lite/fundraisers", 
                loadComponent: () => import('./global/page/donor/donor.component').then( (x) => x.DonorComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Fundraisers",
                }
            },
            { 
                path: "vortex-lite/donor-flags", 
                loadComponent: () => import('./global/page/search/search.page.component').then( (x) => x.SearchPageComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Donor Flags",
                }
            },
            { 
                path: "vortex-lite/club-settings", 
                loadComponent: () => import('./vortex/page/vortex-lite/club-settings/club-settings.component').then( (x) => x.ClubSettingsComponent ),
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Club Settings",
                }
            },

            // ===================================================================
            // APEX
            //--------------------------------------------------------------------
            { 
                path: "apex/my-widgets", 
                component: PageNotFoundComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "My Widgets",
                }
            },
            { 
                path: "apex/apex-settings", 
                component: PageNotFoundComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "APEX Settings",
                }
            },

            // ===================================================================
            // ADMIN TOOLS
            //--------------------------------------------------------------------
            { 
                path: "admin",
                component: AdminComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Admin",
                },

                children: [
                    { 
                        path: "donors-donations", 
                        canActivate: [authGuard],
                        data: {
                            breadcrumb: "Donors And Donations",
                        },
                        children: [
                            {
                                path: "donor-bulk-update",
                                component: DonorBulkUpdateComponent, 
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Donor Bulk Update",
                                },
                            },
                            // TODO: donations-bulk-update folder and file shouldbe renamed to donation-bulk-upload
                            {
                                path: "donation-bulk-upload", 
                                loadComponent: () => import('./vortex/page/donations-upload/donation-upload.component').then((x) => x.DonationUploadComponent ),
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Donation Bulk Upload",
                                    },
                            },
                            {
                              path: "upload-cleaner",
                              loadComponent: () => import('./vortex/page/upload-cleaner/upload-cleaner.component').then((x) => x.UploadCleanerComponent),
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Upload Cleaner",
                                    },
                            }
                        ]
                    },
                    { 
                        path: "campaign-settings", 
                        canActivate: [authGuard],
                        data: {
                            breadcrumb: "Campaign Settings",
                        },
                        children: [
                            { 
                                path: "campaign-list", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Campaign List",
                                }
                            },
                            { 
                                path: "fund-codes", 
                                component: CampaignSettingsFundCodesComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Fund Codes",
                                }
                            },
                            { 
                                path: "donation-source-rates", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Donation Source Rates",
                                }
                            },
                            { 
                                path: "accounting-system", 
                                component: CampaignSettingsAccountingSystemsComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Accounting System",
                                }
                            },
                            { 
                                path: "compliance", 
                                component: CampaignSettingsComplianceComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Compliance",
                                }
                            },
                            { 
                                path: "search-throttle", 
                                component: CampaignSettingsSearchThrottleComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Search Throttle",
                                }
                            },
                            { 
                                path: "donor-campaign-limits", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Donor Campaign Limits",
                                }
                            },
                            { 
                                path: "campaign-types", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Campaign Types",
                                }
                            },
                            { 
                                path: "default-approver", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Default Approver",
                                }
                            }
                        ]
                    },
                    { 
                        path: "organization-settings", 
                        component: PageNotFoundComponent,
                        canActivate: [authGuard],
                        data: {
                            breadcrumb: "Organization Settings",
                        },
                    },
                    { 
                        path: "users",
                        canActivate: [authGuard],
                        data: {
                            breadcrumb: "users",
                        },
                        children: [
                            { 
                                path: "invite-new-user", 
                                component: UserCampaignInviteComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Invite New User",
                                }
                            },
                            { 
                                path: "all-users", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "All Users",
                                }
                            },
                            { 
                                path: "user-bulk-upload", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "User Bulk Upload",
                                }
                            },
                        ]
                    },
                    { 
                        path: "system-errors", 
                        canActivate: [authGuard],
                        data: {
                            breadcrumb: "Campaign Settings",
                        },
                        children: [
                            { 
                                path: "login-errors", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Login Errors",
                                }
                            },
                            { 
                                path: "logout-errors", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Logout Errors",
                                }
                            },
                            { 
                                path: "transaction-errors", 
                                component: PageNotFoundComponent,
                                canActivate: [authGuard],
                                data: {
                                    breadcrumb: "Transaction Errors",
                                }
                            },
                        ]
                    },

                ]
            },

            // CATCH-ALL 
            //--------------------------------------------------------------------
            { 
                path: "", 
                component: CampaignComponent,
                canActivate: [authGuard],
                data: {
                    breadcrumb: "Campaign Selection",
                },
            },
            ]
        },
        {
        path: "styleguide",
        component: StyleguideComponent,
        },

    // { 
    //     path: "**", 
    //     data: {
    //         breadcrumb: "Page Not Found",
    //     },
    //     component: PageNotFoundComponent,
    // },
    ];


/**
 * 
 * @param user 
 */
// export const getRoutesForUser = (user:any):any => {

//     const routes:Array<any> = [];
//     if(user.apps.get("vortex") !== undefined){
//         routes.push(...vortexRoutes);
//         // routes.push(...vortexFECRoutes);
//         // routes.push(...vortexJFCRoutes);
//     }
//     if(user.apps.get("vortex-lite") !== undefined){
//         routes.push(...vortexLiteRoutes);
//     }
//     if(user.apps.get("apex") !== undefined){
//         routes.push(...apexRoutes);
//     }
//     if(user.apps.get("admin") !== undefined){
//         routes.push(...adminRoutes);
//     }

//     console.debug(routes);
//     return routes;
// }
